import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialStoreOrdersFinanceFilterData,
  InitialStoreOrdersFinanceFilterDataVariables
} from "./types/InitialStoreOrdersFinanceFilterData";
import {
  storeOrdersFinance,
  storeOrdersFinanceVariables
} from "./types/storeOrdersFinance";
import {
  storeOrdersFinanceDownload,
  storeOrdersFinanceDownloadVariables
} from "./types/storeOrdersFinanceDownload";

export const storeOrdersFinanceListQuery = gql`
  ${pageInfoFragment}
  query storeOrdersFinance(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: StoreOrdersBiFilterInput!
  ) {
    storeOrdersFinance(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          order_status
          order_date
          order_code
          store_order_code
        }
      }
    }
  }
`;

export const useStoreOrdersListQuery = makeBossQuery<
  storeOrdersFinance,
  storeOrdersFinanceVariables
>(storeOrdersFinanceListQuery);

export const storeOrdersFinanceDownloadQuery = gql`
  ${pageInfoFragment}
  query storeOrdersFinanceDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: StoreOrdersBiFilterInput!
  ) {
    storeOrdersFinance(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          vendor_code
          vertical
          order_status
          store_order_status
          order_date
          completed_at
          store_completed_at
          canceled_at
          order_code
          store_order_code
          shipping_method_name
          payment_method_type
          ipay88_ref_no
          voucher_code
          retail_price
          sales_discount_tenant
          sales_discount_sm
          sales_discount_total
          selling_price
          delivery_fee
          total_gross_transaction
          voucher_discount_tenant
          voucher_discount_sm
          voucher_discount_total
          price_paid
          payment_fee
          payment_fee_vat
          total_payment_fee
          payment_fee_witholding_tax
          credit_card_witholding_tax
          net_settlement
          mdr
          payment_gateway
          cash_handling_fee
          insurance
          transaction_income
          is_payout_eligible
          first_name
          last_name
          contact_no
          email
          order_cancel_reason
          store_order_cancel_reason
          payout_status
          in_store_cash_payment
          gateway_trans_id
          total_subsidy
          discrepancy
          serviceable
        }
      }
    }
  }
`;

export const useStoreOrdersDownloadQuery = makeBossQuery<
  storeOrdersFinanceDownload,
  storeOrdersFinanceDownloadVariables
>(storeOrdersFinanceDownloadQuery);

export const initialStoreOrdersFinanceFilterDataQuery = gql`
  query InitialStoreOrdersFinanceFilterData($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }

    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialStoreOrdersFinanceFilterDataQuery = makeQuery<
  InitialStoreOrdersFinanceFilterData,
  InitialStoreOrdersFinanceFilterDataVariables
>(initialStoreOrdersFinanceFilterDataQuery);
